import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import ListingAddress from '@/features/listing/components/listing-card/listing-address/listing-address';
import ListingRate from '@/features/listing/components/listing-card/listing-rate/listing-rate';
import ListingMessage from '@/features/listing/components/listing-message/listing-message';
import { type ListingWithUser } from '@/features/listing/types/listing-types';
import { type MessageSentSource } from '@/shared/types/report-types';
import styles from './listing-message-modal.module.scss';
interface ListingMessageModalProps {
  listing: ListingWithUser;
  onClose: () => void;
  messageSrc?: MessageSentSource;
}
export default function ListingMessageModal(props) {
  const $ = _c(26);
  const {
    listing,
    messageSrc,
    onClose
  } = props;
  const listingMessageModalTranslations = useTranslations("listing.message");
  let t0;
  if ($[0] !== onClose) {
    t0 = () => {
      setTimeout(() => {
        onClose();
      }, 2000);
    };
    $[0] = onClose;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClose = t0;
  const imageUrl = new URL(listing.images[0].path);
  imageUrl.searchParams.set("auto", "webp");
  imageUrl.searchParams.set("width", 372 .toString());
  imageUrl.searchParams.set("quality", 30 .toString());
  let t1;
  if ($[2] !== listingMessageModalTranslations) {
    t1 = listingMessageModalTranslations("message-to");
    $[2] = listingMessageModalTranslations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== listing.user.firstName || $[5] !== t1) {
    t2 = <div className={styles.listingMessageModal_title}>{t1}{" "}{listing.user.firstName}</div>;
    $[4] = listing.user.firstName;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== listing.title) {
    t3 = <div className={styles.listingMessageModal_listingTitle}>{listing.title}</div>;
    $[7] = listing.title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== listing.addressFormatted || $[10] !== listing.listingTypeId) {
    t4 = <ListingAddress address={listing.addressFormatted} listingTypeId={listing.listingTypeId} />;
    $[9] = listing.addressFormatted;
    $[10] = listing.listingTypeId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== listing.rates) {
    t5 = <ListingRate rate={listing.rates} />;
    $[12] = listing.rates;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <div className={styles.listingMessageModal_card}><div className={styles.listingMessageModal_details}>{t3}{t4}{t5}</div></div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== handleClose || $[19] !== listing || $[20] !== messageSrc) {
    t7 = <ListingMessage listing={listing} onSent={handleClose} messageSrc={messageSrc} />;
    $[18] = handleClose;
    $[19] = listing;
    $[20] = messageSrc;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t2 || $[23] !== t6 || $[24] !== t7) {
    t8 = <div className={styles.listingMessageModal}>{t2}{t6}{t7}</div>;
    $[22] = t2;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}